import type { StepMap } from "@/components/onboarding/components/welcome-wizard";
import { ProactiveTrialStep } from "./proactive-trial-step";

export const ProactiveTrialStepMap: StepMap = {
  "proactive-trial": {
    id: "proactive-trial",
    layout: "wide",
    render: props => <ProactiveTrialStep {...props} />,
  },
};
